import { Injectable } from '@angular/core';
import { RestService, Rest, ABP } from '@abp/ng.core';
import { TerminalManagement } from '../models';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class TerminalManagementService {
	apiName = 'TerminalManagement';

	constructor(private restService: RestService) { }


	register(body: TerminalManagement.RegisterRequest): Observable<TerminalManagement.TerminalItem> {
		const request: Rest.Request<TerminalManagement.RegisterRequest> = {
			method: 'post',
			url: '/api/TerminalManagement/Terminals/register',
			body
		};
		return this.restService.request<TerminalManagement.RegisterRequest, TerminalManagement.TerminalItem>(request, {
			apiName: this.apiName
		});
	}

	deleteTerminal(terminalId: string): Observable<null> {
		const request: Rest.Request<null> = {
			method: 'DELETE',
			url: `/api/TerminalManagement/Terminals/${terminalId}`,
		};

		return this.restService.request<null, null>(request, { apiName: this.apiName });
	}

	getTerminal(id: string): Observable<TerminalManagement.TerminalItem> {
		const request: Rest.Request<null> = {
			method: 'GET',
			url: `/api/TerminalManagement/Terminals/${id}`,
		};

		return this.restService.request<null, TerminalManagement.TerminalItem>(request, { apiName: this.apiName });
	}

	getList(params = {} as TerminalManagement.GetTerminalsRequest): Observable<TerminalManagement.TerminalResponse> {
		const request: Rest.Request<null> = {
			method: 'GET',
			url: '/api/TerminalManagement/Terminals/list',
			params,
		};

		return this.restService.request<null, TerminalManagement.TerminalResponse>(request, { apiName: this.apiName });
	}

	enable(machineCode: string, tenantId: string): Observable<null> {

		const request: Rest.Request<null> = {
			method: 'PUT',
			url: `/api/TerminalManagement/Terminals/enable/${machineCode}/${tenantId}`,
		};

		return this.restService.request<null, null>(request, {
			apiName: this.apiName,
		});
	}

	disable(machineCode: string, tenantId: string): Observable<null> {

		const request: Rest.Request<null> = {
			method: 'PUT',
			url: `/api/TerminalManagement/Terminals/disable/${machineCode}/${tenantId}`,
		};

		return this.restService.request<null, null>(request, {
			apiName: this.apiName,
		});
	}

	update(body: TerminalManagement.UpdateTerminalRequest): Observable<TerminalManagement.TerminalItem> {
		const url = `/api/TerminalManagement/Terminals/${body.id}`;
		delete body.id;

		const request: Rest.Request<TerminalManagement.UpdateTerminalRequest> = {
			method: 'PUT',
			url,
			body,
		};

		return this.restService.request<TerminalManagement.UpdateTerminalRequest, TerminalManagement.TerminalItem>(request, {
			apiName: this.apiName,
		});
	}


}
